export default __webpack_public_path__ + "6f44255edcc0353d4e1c803e110e3698.png";